import React, {useState , useMemo , useCallback, useEffect} from 'react'
import {Flex, Link, Button} from 'components'
import Table, {Cell, Row} from 'components/Table'
import {ACTIVE, OVERDUE, PREVIOUS, MONTHLY, QUARTERLY, SEMI_ANNUALLY, ANNUALLY} from 'payments/constants'
import Group from './Group'
import {get} from 'lodash'
import format from 'lib/format'
import {useToggle} from 'lib/hooks'
import {useTranslation} from 'react-i18next'
import ClubPaymentSubscriptions from './ClubPaymentSubscriptions'
import ClubUserPaymentSubscriptionPlans from './ClubPaymentSubscriptions/ClubUserPaymentSubscriptionPlans'
import ClubUserPaymentSubscriptionCharges from './ClubPaymentSubscriptions/ClubUserPaymentSubscriptionCharges'
import {fetchSubscriptionPlans, fetchSubscriptionPlanCharges, clearSubscriptionPlans, clearSubscriptionCharges} from 'payments/actions'
import {Box, H1, Text, Loading} from 'components'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {getSubscriptions, getSubscriptionPlans, getSubscriptionPlanCharges} from 'payments'

const SubscriptionsTable = ({
    subscriptions,
    subscriptionPlans,
    subscriptionPlanCharges,
    fetchSubscriptionPlans,
    fetchSubscriptionPlanCharges,
    stopSubscriptionHandler,
    clearSubscriptionPlans,
    clearSubscriptionCharges,
    showCreateSubscriptionPlanModal,
    setSubscriptionPlanId,
    subscriptionPlanId
}) => {
 
  const [t] = useTranslation()
  const [clubPaymentSubscriptionsVisible, _showClubPaymentSubscriptions, _hideClubPaymentSubscriptions] = useToggle(true)
  const [clubPaymentSubscriptionPlansVisible, _showClubPaymentSubscriptionPlans, _hideClubPaymentSubscriptionPlans] = useToggle()
  const [clubUserPaymentSubscriptionChargesVisible, _showClubUserPaymentSubscriptionCharges, _hideClubUserPaymentSubscriptionCharges] = useToggle()

  const [subscriptionTitle, setSubscriptionTitle] = useState("")
  const [subscriptionStartDate, setSubscriptionStartDate] = useState("")
  const [subscriptionPlanUserFullName, setSubscriptionPlanUserFullName] = useState("")
  

  const navigateBack = ()=>{
    _hideClubPaymentSubscriptionPlans()
    _showClubPaymentSubscriptions()
    new Promise((resolve, reject) => {
      
      clearSubscriptionCharges({resolve, reject})
      return clearSubscriptionPlans({resolve, reject});
    })
  }

  const navigateBackToSubscriptionPlans = ()=>{
    showPaymentSubscriptionPlans(subscriptionPlanId, subscriptionTitle, subscriptionStartDate);
  }

  const showPaymentSubscriptionPlans = useCallback((id, title, startDate) => {
    new Promise((resolve, reject) => {
      let parameters = {
        subscriptionId: id
      };
      setSubscriptionPlanId(id);
      clearSubscriptionPlans({resolve, reject})
      fetchSubscriptionPlans({resolve, reject, values: parameters}) 
      
    })
    _hideClubPaymentSubscriptions();
    _hideClubUserPaymentSubscriptionCharges();
    _showClubPaymentSubscriptionPlans(id);

    setSubscriptionTitle(title);
    setSubscriptionStartDate(startDate);
    
  }, [_hideClubPaymentSubscriptions, _hideClubUserPaymentSubscriptionCharges, _showClubPaymentSubscriptionPlans])

  const showPaymentSubscriptionCharge = useCallback((id, title) => {
    setSubscriptionPlanId(id);
    
    new Promise((resolve, reject) => {
      let parameters = {
        subscriptionPlanId: id
      };

      fetchSubscriptionPlanCharges({resolve, reject, values: parameters})
    })

    setSubscriptionPlanUserFullName(title);
    _hideClubPaymentSubscriptions();
    _hideClubPaymentSubscriptionPlans();
    _showClubUserPaymentSubscriptionCharges(id);
  }, [_hideClubPaymentSubscriptionPlans, _showClubUserPaymentSubscriptionCharges])

  return (
    <Flex flexDirection="column">
      <Table>
        {clubPaymentSubscriptionsVisible && ( 
          <>
            <Row header>
              <Cell light bold width={3 / 6}>
                {t('Title')}
              </Cell>
              <Cell bold light width={1 / 4}>
                {t('Amount')}
              </Cell>
              <Cell light bold width={1 / 4}>
                {t('Interval')}
              </Cell>
            </Row>
            
               <ClubPaymentSubscriptions
                stopSubscriptionHandler={stopSubscriptionHandler}
                subscriptions={subscriptions}
                showPaymentSubscriptionPlans={showPaymentSubscriptionPlans}
              />
            
          </> 
        )}

        {clubPaymentSubscriptionPlansVisible && (
          <>

            <Flex mb={3} style={{justifyContent: "space-between"}}>             
                <Button primary onClick={()=>{
                  navigateBack()

                }}>{t('Tilbage')}</Button>

                <Button mr={3} primary alignSelf={"flex-end"} onClick={()=>{showCreateSubscriptionPlanModal()}}>
                  {t('Opret abonnementplan')}
                </Button>
            </Flex>
            <Flex mb={3}>
              <H1><strong>{t('Subscription name')}</strong> {subscriptionTitle}</H1>
            </Flex>
            <Flex mb={3}>
              <strong style={{marginRight: '5px'}}>{t('Start Dato')}</strong> <span>{format(subscriptionStartDate, 'DD/MM-YYYY HH:mm')}</span>
            </Flex>
            <Flex mb={3}>
              {t('Liste af alle medlemmer med abonnement')}
            </Flex>

            <Row header>
              <Cell light bold width={80 / 8 / 100}>
                {t('Id')}
              </Cell>
              <Cell light bold width={100 / 8 / 100}>
                {t('Fuldenavn')}
              </Cell>
              <Cell bold light width={80 / 8 / 100}>
                {t('Pris')}
              </Cell>
              <Cell light bold width={80 / 8 / 100}>
                {t('Interval')}
              </Cell>
              <Cell light bold width={100 / 8 / 100}>
                {t('Status')}
              </Cell>
              <Cell light bold width={100 / 8 / 100}>
                {t('Start dato')}
              </Cell>
              <Cell light bold width={100 / 8 / 100}>
                {t('Slut dato')}
              </Cell>
              <Cell light bold width={160 / 8 / 100}>
                {t('Ekstern Id')}
              </Cell>
            </Row>
            
            <ClubUserPaymentSubscriptionPlans
              clubUserPaymentSubscriptionPlans={subscriptionPlans}
              showPaymentSubscriptionCharge={showPaymentSubscriptionCharge}
            /> 
          </>
        )}

        {clubUserPaymentSubscriptionChargesVisible && (   
          <>
            <Flex mb={3}>             
                <Button primary onClick={()=>{
                  navigateBackToSubscriptionPlans()

                }}>{t('Tilbage')}</Button>

            </Flex>
            <Flex mb={1}>
              <H1><strong>{t('Abonnement navn')}</strong> {subscriptionTitle}</H1>
            </Flex>
            <Flex mb={3}>
              <strong style={{marginRight: '5px'}}>{t('Medlems fuldenavn')}</strong> <span>{subscriptionPlanUserFullName}</span>
            </Flex>
            <Flex mb={3}>
              {t('Liste af opkrævninger')}
            </Flex>

            <Row header>
              <Cell light bold width={100 / 6 / 100}>
                {t('Order nummer')}
              </Cell>
              <Cell bold light width={80 / 6 / 100}>
                {t('Pris')}
              </Cell>
              <Cell light bold width={100 / 6 / 100}>
                {t('Deadline')}
              </Cell>
              <Cell light bold width={100 / 6 / 100}>
                {t('Betalingsdato')}
              </Cell>
              <Cell light bold width={100 / 6 / 100}>
                {t('Status')}
              </Cell>
              <Cell light bold width={120 / 6 / 100}>
                {t('Ekstern Id')}
              </Cell>
            </Row>

            <ClubUserPaymentSubscriptionCharges
              subscriptionCharges={subscriptionPlanCharges}                 
            />
          </>                
        )}

      </Table>
      
    </Flex>
  )
}

const enhancer = connect(
  createStructuredSelector({
    subscriptions: getSubscriptions,
    subscriptionPlans: getSubscriptionPlans,
    subscriptionPlanCharges: getSubscriptionPlanCharges,
  }),
  {
    fetchSubscriptionPlans: fetchSubscriptionPlans.requested,
    fetchSubscriptionPlanCharges: fetchSubscriptionPlanCharges.requested,
    clearSubscriptionPlans: clearSubscriptionPlans.requested,
    clearSubscriptionCharges: clearSubscriptionCharges.requested
  }
)

export default enhancer(SubscriptionsTable)